import GlobalConfig from "../globalConfig";
import { serialize } from "../helper";

//import { TABLE_CONFIG } from "../constant";
export const keycloakUserLogin = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/auth/keycloakSignIn"),
  data: { ...data }
});

export const userLoginParams = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/auth/keycloakLogin"),
  // url: GlobalConfig.getApiUrlFromRoot("/auth/signin"),
  // url: GlobalConfig.getMockUrl("/login"),
  // url: "http://www.mocky.io/v2/5d0b55082f00002b00e3efc9",
  data: { ...data }
});

export const _userSecurityKey = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/auth/security/key"),
  data: data
});

export const _userLoginRequest = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/auth/loginRequest"),
  data: data
});

export const _userSecurityKeyV2 = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/auth/security/v2/key"),
  data: data
});

export const userLoginWithOTPParams = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/auth/validateOTP`),
  // url: GlobalConfig.getMockUrl("/login"),
  // url: "http://www.mocky.io/v2/5d0218983100005e00ab2c47",
  data: data
});

export const userLoginGenerateOTPParams = mobileNumber => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/auth/generateOTP/${mobileNumber}`)
  // url: GlobalConfig.getMockUrl("/login"),
  // url: "http://www.mocky.io/v2/5d0218983100005e00ab2c47",
});

export const userSignUpParams = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/user/signup"),
  // url: "http://www.mocky.io/v2/5d0368b130000056001f4c5d",
  data: { ...data }
});

export const verifySignUpOTPParams = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/user/user/validateVerifiedOtp"),
  // url: "http://www.mocky.io/v2/5d034e4430000066001f4b77",
  data: { ...data }
});

export const userInfoUpdateParams = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/user/contactInfo"),
  // url: "http://www.mocky.io/v2/5d034e4430000066001f4b77",
  data: { ...data }
});

export const sendSignUpOtpParams = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/user/otp/sendOtp"),
  // url: "http://www.mocky.io/v2/5d034e4430000066001f4b77",
  data: data
});

export const sendVerificationOTPParams = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/user/otp/sendVerificationOTP"),
  data: data
});

export const getMeetingDetailsforPRAGATI = (data = {}) => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/mom/pragati-date-list`),
  data: { ...data }
});

export const getMeetingDetailsAfterSearchforPRAGATI = (data = {}) => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/mom/pragati-date-list/${data}`),
  data: { ...data }
});
export const isUserExistParams = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/user/isUserExist"),
  // url: "http://www.mocky.io/v2/5d034e4430000066001f4b77",
  data: { ...data }
});

export const userLogoutParams = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/doLogout"),
  // url: GlobalConfig.getMockUrl("/logout"),
  data
});

export const userLogout = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  // url: GlobalConfig.getApiUrlFromRoot("/auth/logout")
  url: GlobalConfig.getApiUrlFromRoot("/auth/keycloakLogout"),
  // url: GlobalConfig.getMockUrl("/logout"),
  data
});

export const userForgetPasswordParams = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/auth/forgetPassword`),
  data
});

export const userResetPasswordParams = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/auth/resetPassword"),
  data: { ...data }
});

export const isUserValidForResetPassword = (data = {}) => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/auth/resetToken/validate"),
  data: { ...data }
});

//****************************** Create Project  ****************************//

export const createProject = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/project/project"),
  data: { ...data }
});

export const editProject = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/project/update`),
  data: { ...data }
});

export const editProjectMilestones = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/project/updateMilestones`),
  data: { ...data }
});

export const deletePP = (data, projectId) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/project/deletePP/${projectId}`),
  data
});

export const getProjectPageInfo = (isEdit = false, projectId) => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/project/page${isEdit ? `?projectId=${projectId}` : ""}`
  )
});

export const getOtp = () => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/auth/changePasswordRequest`)
});

export const getSubSectorsById = (data = {}) => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/sector/subSector`),
  data: { ...data }
});

export const getBucketsWithMilestonesBySector = sectorId => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/bucket/milestones?sectorId=${sectorId}`
  )
});

export const getResponsibleAuthorityMilestone = () => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/responsibleAuthority/list`)
});

export const getSchemesList = (data = {}) => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/sector/scheme`),
  data: { ...data }
});

export const getCostDistance = (data = {}) => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/sector/costDistance`),
  data: { ...data }
});

export const getValidateCin = (data = {}) => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/project/cin`),
  data: { ...data }
});

/*             File Upload                */
export const uploadFile = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["MULTIPART_FORM_DATA"]),
  url: GlobalConfig.getApiUrlFromRoot(`/auth/fileManger/uploadFile`),
  data
});

export const removeFile = (data = {}) => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/fileManger/deleteFile?${serialize(data)}`
  )
});

export const getProjectDetails = (data = {}) => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/project/detail/${data.id}`),
  data: { ...data }
});

export const getProjectDetailsforPragti = (data = {}) => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/mom/pragati/${data}`),
  data: { ...data }
});

export const getProjectDecisionDetails = data => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/project/show/${data}`)
});

export const _getProjectTimelineData = id => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/project/timeline/${id}`)
});

export const getGroupById = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/user/group/category`),
  data
});

export const getGroupsByCategory = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/user/group/getGroupsByCategory`),
  data
});

export const getGroupByCategoryAndParentId = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/issue/getGroupByCategoryAndParentId`
  ),
  data
});

export const uploadFileTitle = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/fileManger/updateTitle?${serialize(data)}`
  )
});

export const getissueListParams = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/issue/list`),
  data: { ...data }
});

export const getIssueListParamsForAgendaSelect = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/issue/list/agenda`),
  data: { ...data }
});

export const getIssueDetails = (data = {}) => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/issue/detail/${data.issueId}`)
});

export const getIssuesReviewed = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/mom/mis/issuesReviewed`),
  data: { ...data }
});

export const getIssuesResolved = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/mom/mis/issuesResolved`),
  data: { ...data }
});

export const getIssuesPending = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/mom/mis/issuesPending`),
  data: { ...data }
});

export const getIssuesTimelineLapsed = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/mom/mis/issuesTimelineLapsed`),
  data: { ...data }
});

export const getmeetingsCount = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/mom/mis/meetingsCount`),
  data: { ...data }
});

export const getmeetingsDate = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/mom/mis/meetingsDate`),
  data: { ...data }
});

export const getIssueMeetingsById = id => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/issue/issueMeetings/${id}`)
});

export const getProjectList = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/project/list`),
  data: { ...data }
});

/////////////////////////////////////////////////////
//////////     Get Issues Category List //////////////////////

export const getIssuesCategoryList = (data = {}) => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/issueCategory/`),
  data
});

export const getIssuesSubCategoryList = (data = {}) => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/issueSubCategory/`),
  data
});

export const getForumList = id => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/issueForum?category=${id}`)
});

////////////////////////////////////////////////////////
/////////       CREATE ISSUES   ///////////////////////

export const createIssues = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/issue`),
  data
});

export const updateIssues = (data = {}, id) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/issue/update/${id}`),
  data
});

// Workflow Configs

export const fetchWorkflowActionsData = () => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/project/action")
});

export const createMomParams = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/project/mom/create"),
  data: { ...data }
});

export const getMomDetailsParams = (data = {}) => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/mom/${data.momId}`)
});

export const getAllMomsParams = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/project/mom/list"),
  data: { ...data }
});
export const getAllPRAGATILists = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/project/mom/pragati-list"),
  data: { ...data }
});
export const updateMomParams = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/mom/${data.id}`),
  data: { ...data }
});

export const daterangeForAll = (data = {}) => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/mom/date-range`)
  // data: { ...data }
});

export const agendaHistoryParams = (data = {}) => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/mom/history/${data.id}`)
});

export const upcomingMOMParams = (data = {}) => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/issue/upcomingMeeting/${data.id}`
  )
});

export const deleteMOMParams = (data = {}) => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/mom/deleteAgenda/${data.id}`)
});

export const submitCommentOnIssueParams = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/`),
  data: { ...data }
});

export const _getAgendaSummary = id => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/mom/summary/${id}`)
});

export const issueAgeingReportParams = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/`),
  data: { ...data }
});

export const upcomingMeetingsParams = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/`),
  data: { ...data }
});

export const issueActivityHistoryParams = (data = {}) => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/issue/activityOther`),
  data: { ...data }
});

export const issueActivityCommentParams = (data = {}) => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/issue/activityComment`),
  data: { ...data }
});

export const addDecisionParams = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/mom/addDecision`),
  data: { ...data }
});

export const createWorkflowAction = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/project/action"),
  data: data
});

export const deleteWorkflowAction = id => ({
  method: "DELETE",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/action?${id}`)
});

export const fetchWorkflowStateCategoryData = () => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/project/stateCategory")
});

export const createWorkflowStateCategory = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/project/stateCategory"),
  data: data
});

export const deleteWorkflowStateCategory = id => ({
  method: "DELETE",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/stateCategory?${id}`)
});

export const fetchWorkflowStateData = () => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/project/workflowState")
});

export const fetchWorkflowStateDataForCentral = () => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/project/workflowState/central")
});

export const createWorkflowState = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/project/workflowState"),
  data: data
});

export const deleteWorkflowState = id => ({
  method: "DELETE",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/workflowState?${id}`)
});

export const fetchWorkflowData = () => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/project/workflow")
});

export const createWorkflow = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/project/workflow"),
  data: data
});

export const _workflowtype = () => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/project/workflow/getAllWorkflowType")
});

/////////////////////////////////////////////////
/////////// USER MANAGEMENT   ///////////////////

export const getRolesList = () => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/user/role/`)
});
// Workflow Configs

export const getGroupsList = () => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/user/group/getMyGroups`)
});

export const _getGroupsList = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/user/group/list"),
  data
});

export const getGroups = () => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/user/group/getGroups")
});

export const _getGroupListFilter = () => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/user/group/list/filter")
});

export const getGroupsForUsers = () => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/user/group/v2/getGroups")
});

export const getCategoryList = () => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/user/group/getCategory")
});

export const getCategoryForRoleList = () => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/user/group/getGroupCategoryForRole")
});

export const createGroup = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/user/group/create"),
  data
});

export const updateGroup = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/user/group/update"),
  data
});

export const deleteGroup = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/user/group/delete"),
  data
});

export const getGroupRoles = (data = {}) => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/user/getGroupRoles"),
  data
});

////////////////////////  Create User //////////////////////

export const createUser = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/user/user/create"),
  data
});

export const updateUser = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/user/user/updateUser"),
  data
});

export const updateBestPractices = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    "/user/bestPractices/updateBestPractices"
  ),
  data
});

export const createBestPractices = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    "/user/bestPractices/createBestPractices"
  ),
  data
});

export const deleteBestPractice = id => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/user/bestPractices/deleteBestPractices?id=${id}`
  )
});

export const getRolesById = (data = {}) => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/user/getGroupRoles?${serialize(data)}`)
});

export const _getGroupRolesForUser = id => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/user/getGroupRolesForUser?groupId=${id}`
  )
});

export const getUsersList = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/user/user/listUsers"),
  data
});

export const getBestPracticesList = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/user/bestPractices/listBestPractices"),
  data
});

export const getBestPracticesCount = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/user/bestPractices/bestPracticesCount"),
  data
});

export const getBestPracticesListForHome = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/project/home/listBestPractices"),
  data
});

export const getBestPracticesCountForHome = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/project/home/bestPracticesCount"),
  data
});

export const getGroupsByCategoryAction = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/project/home/getGroupsByCategory"),
  data
});

export const getIIGDraftUsersList = (data = {}) => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/user/user/listDraftUser"),
  data
});

export const getDraftUserCount = (data = {}) => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/user/user/getDraftUserCount") // IIG user count
});

export const getGuestListParams = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/project/issue/guests"),
  data
});

////////////////////////  Create Roles //////////////////////

export const createRole = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/user/role/update"),
  data
});

export const getPermissionsListing = (data = {}) => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/user/permission/myPermissions") // myPermissions
});

export const deleteRole = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/user/role/delete"),
  data
});

export const getCreateAgengaPageInfo = (data = {}) => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/mom/loadPage`),
  data
});

export const misFilterParams = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/`),
  data: { ...data }
});

export const projectMinistryParams = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/auth/mis/getGroupIssueReport`),
  data: { ...data }
});

export const projectSchemeParams = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/auth/mis/getGroupProjectReport`),
  data: { ...data }
});

export const projectMultiLocationParams = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/auth/mis/getIssueLocationReport`),
  data: { ...data }
});

export const projectSingleLocationParams = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/auth/mis/getLocationProjectReport`),
  data: { ...data }
});

export const issueState = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/auth/mis/getIssueStateReport`),
  data: { ...data }
});

export const issueStatus = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/auth/mis/getIssueStatusReport`),
  data: { ...data }
});

export const projectStatus = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/auth/mis/getProjectStatusReport`),
  data: { ...data }
});

export const changeProjectStatusParams = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/project/status`),
  data: { ...data }
});

export const schemeProject = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/auth/mis/getSchemeProjectReport`),
  data: { ...data }
});

export const fetchProjectReport = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/auth/mis/getProjectReport`),
  data: { ...data }
});

export const fetchStateProjectReport = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/project/misListReport`),
  data: { ...data }
});

export const fetchProjectDetail = (id = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/auth/mis/getProjectDetail?id=${id}`)
});

// Dashboard
export const getDashboardSummary = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/dashboard/summary?march24=${data.march24}`
  ),
  data: { ...data }
});

export const getProjectsByScheme = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/dashboard/projectsBySchemes`),
  data: { ...data }
});

export const getIssuesByCategoryForGanttChart = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/dashboard/issuesByCategoryForGanttChart`
  ),
  data: { ...data }
});

export const getIssuesByCategory = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/dashboard/issuesByCategory?march24=${data.march24}`
  ),
  data: { ...data }
});

export const getPendingIssuesBy = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/dashboard/pendingIssues?march24=${data.march24}`
  ),
  data: { ...data }
});

export const getProjectsBy = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/dashboard/getProjectBy?march24=${data.march24}`
  ),
  data: { ...data }
});

export const getProjectsByLocation = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/dashboard/getProjectByLocation?march24=${data.march24}`
  ),
  data: { ...data }
});

export const getDashboardNotifications = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/dashboard/notification`),
  data: { ...data }
});

export const getDashboardNotificationsViewed = id => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/dashboard/changeNotificationViewStatus`
  ),
  data: id
});

export const getDashboardNotificationsAllViewed = workflowType => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/dashboard/changeAllNotificationsViewStatus${
      workflowType ? `?workflowType=${workflowType}` : ""
    }`
  )
});

export const getNotificationsStatus = id => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/dashboard/status/${id}`)
});

export const getNotificationUpdates = () => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/dashboard/notificationUpdates`)
});

export const getAllState = () => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/state`)
});

export const getMisList = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/project/issue/misIssueSummary"),
  data
});

export const getMisReportList = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/project/mom/misreport"),
  data
});

export const getMisissueSummaryFileDownload = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/auth/excel/downloadReport"),
  data
});

export const getMisissueSummaryFileCreate = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/auth/excel/misPendingIssueReport"),
  data
});

/////////////////////////  Add Decision /////////////////
export const addDecision = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/project/mom/addDecision"),
  data
});

export const addProjectDecision = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/project/project/createProjectDecision"),
  data
});

export const getMinistryListById = id => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/project/${id}`)
});

export const changePasswordParams = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/user/user/changePassword`),
  data: { ...data }
});

export const getChangePasswordOTP = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/auth/resetPasswordOtpvalidate`),
  data: { ...data }
});

///////////////////////   Issue Actions   /////////////////////
export const setIssueStatus = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/project/issue/changeState"),
  data
});

export const postComment = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/project/issue/comment"),
  data
});

export const issueClarification = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/project/issue/clarification"),
  data
});

export const forwardToTeam = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/project/issue/forwardToTeam"),
  data
});

export const reply = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/project/issue/replyTo"),
  data
});

export const guestList = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/project/issue/guests"),
  data
});

export const getActions = id => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/issue/action/${id}`)
});

export const issuesGuestList = (data = {}) => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/project/issue/states"),
  data
});

export const fetchAllSchemes = (data = {}) => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/scheme/getAllSchemes`)
});

export const fetchAllProjectStatus = () => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/project/getStatuses`)
});

export const fetchImplementationModes = () => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/project/getImplementationMode`)
});

export const getProjectDetail = id => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/project/edit/${id}`)
});

export const declareMonthlyIssue = (data, projectId) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/project/declare-issues/${projectId}`
  ),
  data
});

export const _getDraftedProjectDetails = () => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/project/getProjectDraft`)
});

export const getMeetingTypes = () => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/project/getMeetingTypes`)
});

export const createProjectDecision = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/project/project/createProjectDecision"),
  data
});

// download reports
export const downloadProjectSummary = (report, data) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/auth/excel/uploadReport?report=${report}`
  ),
  data: { ...data }
});

export const uploadProjectSummary = key => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/auth/excel/downloadReport`),
  data: { ...key }
});

// mis reports

export const fetchFlatFileReport = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/auth/mis/getFlatFile`),
  data: { ...data }
});

export const fetchAllIssueCategories = () => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/issueCategory/`)
});

export const fetchAllSectors = () => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/sector`)
});

export const fetchIssueSubCategories = id => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/issueSubCategory/?issueCategoryId=${id}`
  )
});

export const getKanBanList = () => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/kanban`)
});

export const getAgeing = data => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/issue/ageing`),
  data
});

export const getAgeingTree = data => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/issue/ageingTree`),
  data
});

export const getUpCommingMeetings = id => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/issue/upcomingMeeting/${id}`)
});

export const fetchMeetings = (date, data) => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/dashboard/meetings/${date}?march24=${data}`
  )
});

export const dashboardPendingTaskParams = (data = {}) => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/project/dashboard/pendingAction")
});

export const PendingTaskResolvedCommentParams = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/project/mom/resolve"),
  data
});

export const getKanbanList = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/project/dashboard/kanban/issueList"),
  data
});

export const getPragartiProjectsInfo = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/dashboard/getPragatiProjectBy?march24=${data.march24}`
  ),
  data
});

export const getDelayedProjects = data => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/dashboard/delayProjects${
      data.delayedProjectModeSelect
        ? `?implementationMode=${data.delayedProjectModeSelect}&march24=${
            data.march24
          }`
        : `?march24=${data.march24}`
    }`
  )
});

export const bannerMonitoredDataAPI = () => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/project/home/projectMonitored")
});

export const stateWiseProjectsAPI = () => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/home/projectsByState`)
});

export const sectorWiseProjectsAPI = () => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/home/projectsBySector`)
});

export const getLatestNewsAPI = (number = 10) => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: `https://www.investindia.gov.in/invest/api/v1/pmg-news?number=${number}`
  // url: `https://uat.investindia.gov.in/invest/api/v1/pmg-news?number=${number}`
});

export const getBlogsAPI = (number = 6) => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: `https://www.investindia.gov.in/invest/api/v1/pmg-blogs?number=${number}&tag=1393`
  // url: `https://uat.investindia.gov.in/invest/api/v1/pmg-blogs?number=${number}&tag=1393`
});

export const latestNewsFeedsAPI = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/news`),
  data: { ...data }
});

export const projectDuplicateAPI = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/project/project/duplicate"),
  data
});

export const downloadMinuteAPI = id => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/word/downloadAgenda?agendaId=${id}`
  )
});

export const downloadAgendaBriefAPI = id => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/word/downloadAgendaBriefDoc`),
  data: id
});

export const downloadAgendaParticipantsAPI = id => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/word/downloadAgendaParticipantsDoc`
  ),
  data: id
});

export const sendMinuteAPI = id => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/mom/sendMinutes/${id}`)
});

export const issueDuplicateAPI = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/project/issue/duplicate"),
  data
});

export const getAgendaIssueActionAPI = (issueId, checkAgenda) => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/issue/issueMeetings/${issueId}?checkAgenda=${checkAgenda}`
  )
});

export const getAutoCompleteList = id => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/user/user/list?tag=${id}`)
});

export const getUrlDownloadIssuesWithComment = () => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/auth/excel/downloadIssueReportWithComments`
  )
});

export const getUrlDownloadIssuesWithDecision = () => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/auth/excel/downloadIssueReportWithDecision`
  )
});

export const downloadIssuesWithDecision = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/auth/excel/downloadReport`),
  data: { ...data }
});

export const getStateDistrictAndDepartment = (id, state = false) => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/issue/getDistrictAndDepartment?parentId=${id}&includeStatePmg=${state}`
  )
});

export const getStateDistrictAndDepartmentCreateProject = (
  id,
  state = false
) => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/issue/getDistrictAndDepartmentProject?parentId=${id}&includeStatePmg=${state}`
  )
});

export const getDistrictAndDepartmentIssues = (
  id,
  state = false,
  department
) => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/issue/getDistrictAndDepartmentIssues?parentId=${id}&includeStatePmg=${state}&includeDepartments=${department}`
  )
});

export const getDivisions = (id, state = false) => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/issue/getDivisions?parentId=${id}`
  )
});

export const getSectorBasedOnSponsoringDepartment = groupId => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/project/getSectorBasedOnSponsoringDepartment?groupId=${groupId}`
  )
});

export const getStateDistrict = id => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/project/getStateDistrict?stateId=${id}`
  )
});

export const getDownloadMinistryStateIssueReport = id => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/word/downloadProjectInformationReport/${id}`
  )
});

export const getDownloadUserDetails = id => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/auth/excel/downloadUserDetails`)
});

export const isEditGroupManagmentRuning = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/auth/excel/groupEdit`),
  data
});

export const downloadIssuesListReport = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/auth/excel/downloadIssueFile`),
  data: { ...data }
});

export const downloadProjectListReport = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/auth/excel/downloadProjectFile`),
  data: { ...data }
});

export const downloadAgendaListReport = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/auth/excel/downloadMeetingReport`),
  data: { ...data }
});

export const downloadReports = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/auth/excel/downloadReport`),
  data: { ...data }
});

export const getProjectStokeHolderInfo = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/project/getProjectStackHolders`
  ),
  data: { ...data }
});

export const getIssueStokeHolderInfo = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/issue/getIssueStackHolders`),
  data: { ...data }
});

export const getAgendaStokeHolderInfo = id => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/mom/getMeetingStackHolders`),
  data: id
});

export const sendSmsApi = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/sendSMS`),
  data: { ...data }
});

export const sendEmailApi = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/sendMail`),
  data: { ...data }
});

export const makeUserActiveApi = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/user/user/getUserActiveProjectIssueMeeting`
  ),
  data
});

//////////////////////////////////////////////////////////////////////

export const getNotificationActiveInfoApi = (data = {}) => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/project/notificationCheck"),
  data
});

export const setNotificationActiveInfoApi = param => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/project/enableDisableNotification"),
  data: param
});

export const setScheduledMeetingReminder = param => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    "/project/mom/sendScheduledMeetingReminder"
  ),
  data: param
});

export const getMeetingCardInfoApi = param => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/project/mom/getMeetingCardInfo"),
  data: param
});

export const getUsersInfo = data => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/user/user/viewProfile`),
  data
});
//// Nodal Officer ///////////
export const getNodalUserDetails = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/auth/mis/getNodalUserDetails`),
  data
});

export const getDownloadNodalUserSummary = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/auth/excel/downloadNodalUserDetails`),
  data
});

export const updateDownloadNodalComment = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/user/user/addNodalUserComment`),
  data
});

export const getDownloadWeeklyReportSummary = () => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/word/downloadWeeklyReport`)
});

export const _downloadWeeklyReportForStatePmg = () => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/word/downloadStateWeeklyReport`)
});

export const downloadIssuesBriefReport = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/word/downloadIssueBriefDoc`),
  data: { ...data }
});

export const downloadIssuesBriefPDFReport = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/pdf/downloadIssueBriefDoc`),
  data: { ...data }
});

export const _downloadAgendaMeetingPpt = meetingId => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/mom/monitoring_group/ppt/${meetingId}`
  )
});

export const downloadAgendaCabSecPpt = meetingId => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/mom/ppt/CabSec/${meetingId}`)
});

export const downloadAgendaPragatiFormatPpt = meetingId => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/mom/ppt/v3/${meetingId}`)
});

export const _downloadAgendaMeetingPptv2 = (
  meetingId,
  preset = false,
  isWithComment = false
) => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/mom/ppt/v2/${meetingId}?preset=${preset}&isWithComment=${isWithComment}`
  )
});

export const _getMilestoneGanttChart = projectId => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/project/getMilestoneGanttChart/${projectId}`
  )
});

export const _downloadAgendaMeetingExcel = meeting => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/auth/excel/downloadAgendaIssuesReport/${meeting}`
  )
});
export const _downloadMarch24ReportExcel = () => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/word/march24ComplianceReport`)
});

export const downloadDashboardSummary = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/auth/excel/downloadDashboardSummary?march24=${data.march24}`
  ),
  data: { ...data }
});

export const showTeamSection = () => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/dashboard/showTeamSection`)
});

export const downloadExcel = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/auth/excel/downloadReport`),
  data: { ...data }
});

export const getRecipientMinistryState = data => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/user/group/getRecipientMinistryState`),
  data: { ...data }
});

//**************************************** */
//*****************Download Agenda ******* */
export const getDownloadAgenda = meetingId => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/mom/downloadMeetingCSV`),
  data: meetingId
});

export const getUploadAgenda = (meetingId, data) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/mom/uploadMeetingCSV?meetingId=${meetingId}`
  ),
  data: data
});

export const setUpdatingMeetingFiles = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/mom/updateMeetingFiles`),
  data
});
///////////////////////////////////////////////////@ts-ignore
////////////  Product comments and updates //////////////

export const getProjectComments = id => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/project/projectComment?projectId=${id}`
  )
});

export const getProjectUpdates = id => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/project/projectUpdates?projectId=${id}`
  )
});

///
export const getDashboardUpcomingMettings = data => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/dashboard/upcomingMeeting?march24=${data}`
  )
});

//getChildGroupIssuesData
export const getChildGroupIssuesData = data => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/dashboard/getChildGroupIssuesData?march24=${data}`
  )
});
export const getCostOverrunProjects = data => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/dashboard/projectsCostOverRun${
      data.costOverrunProjectModeSelect
        ? `?implementationMode=${data.costOverrunProjectModeSelect}&march24=${
            data.march24
          }`
        : `?march24=${data.march24}`
    }`
  )
});

export const getPmgMeetingStatus = () => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/chartReport/pieChart/PMGMeetingStatus`
  )
});

export const getDownloadMinistryState = id => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/word/downloadPendingIssueReport`
  ),
  data: id
});

export const getDownloadMinistryCompliance = id => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/auth/excel/downloadMISProjectSummary`),
  data: id
});

export const getDownloadStateCompliance = id => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/auth/excel/downloadMISStateProjectSummary`
  ),
  data: id
});

export const getDocumentsData = () => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/auth/mis/getDocumentView`)
});

export const downloadMilestoneAudit = id => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/auth/excel/downloadMilestoneAudit/${id}`
  )
});

export const getDownloadProjectDetail = params => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/word/downloadProjectBriefDoc`),
  data: params
});

export const getChildIssues = id => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/issue/getNotClosedChildIssues`),
  data: id
});

export const saveProjectNote = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/project/editNote`),
  data
});

export const _saveProjectComment = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/project/comment`),
  data
});

export const getProjectNote = projectId => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/project/fetchNote?projectId=${projectId}`
  )
});

// migrate project
export const migrateProjectApi = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/project/migrateProject`),
  data
});

export const getMigrateProjectListApi = id => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/project/getProjects?userId=${id}`
  )
});

// user manual
export const getUserManualList = () => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/getAllUserManuals`)
});

export const uploadUserManual = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/uploadUserManual`),
  data
});

export const getUserManual = () => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/userManual`)
});

export const getUserManualCategoryList = () => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/user/group/getAllCategories`)
});

export const getDashboardPendingTasks = data => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    // `/project/dashboard/pendingTasks?march24=${data.falseD}&groupCategory=${
    //   data.centralDa
    // }&zoneId=${data.zoneId}`
    //data.zoneId
    data.zoneId && data.zoneId !== "0"
      ? `/project/dashboard/pendingTasks?march24=${data.falseD}&groupCategory=${
          data.centralDa
        }&zoneId=${data.zoneId}`
      : `/project/dashboard/pendingTasks?march24=${data.falseD}&groupCategory=${
          data.centralDa
        }`
  )
});

//////////////////     Reports      ////////////////////////
export const getPMGMonitoredIssuesService = data => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/chartReport/lineGraph/issues?march24=${data}`
  )
});

export const getPMGMonitoredProjectService = data => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/chartReport/barGraph/verifiedProjects?march24=${data}`
  )
});

export const getIssueByCategoryService = () => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/chartReport/pieChart/issuesByCategory`
  )
});

// Dashboard Projects Status Graph
export const getProjectsByCompletionStageService = data => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/chartReport/barGraph/projectsByCompletionStage?march24=${data}`
  )
});

export const getProjectsByImplementationModeService = data => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/chartReport/pieChart/projectsByImplementationMode?march24=${data}`
  )
});

export const getUnderImplementationProjectsBySectorService = data => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/chartReport/graph/underImplementationProjectsBySector?march24=${data}`
  )
});

export const getProjectsStatusWithRespectToIssueStatusService = () => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/chartReport/pieChart/projectsStatusWithRespectToIssueStatus`
  )
});

export const getOpenProjectsByImplementationModeService = () => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/chartReport/pieChart/openProjectsByImplementationMode`
  )
});

export const getOpenProjectSectorDistributionService = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/chartReport/barGraph/openProjectSectorDistribution`
  ),
  data
});

export const getProjectCostOverRunDistributionService = data => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/chartReport/pieChart/underImplementationProjectCostOverRun?march24=${data}`
  )
});

export const getProjectDelayedDistributionService = data => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/chartReport/pieChart/underImplementationDelayProjects?march24=${data}`
  )
});

export const getResolvedProjectSectorDistributionService = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/chartReport/barGraph/resolvedProjectSectorDistribution`
  ),
  data
});

export const getProjectSectorDistributionByCreatedDateService = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/chartReport/barGraph/projectSectorDistributionByCreatedDate`
  ),
  data
});

export const getShowSponsorRecipientFilterService = data => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/dashboard/showSponsorRecipientFilter`
  ),
  data
});

export const getShowStateAndCentralFilterService = () => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/dashboard/showStateAndCentralFilter`
  )
});

export const getWorkflowStatesServices = () => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/issue/getWorkflowStates`)
});

export const _unHoldIssueAction = id => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/issue/unhold?issueId=${id}`)
});

export const _getParentGroupsByCategory = param => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/user/group/getParentGroupsByCategory?category=${param}`
  )
});

export const _getDistrictDepartmentByParentIds = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/user/group/getDistrictDepartmentByParentIds`
  ),
  data: data
});

export const _markAsDuplicate = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/issue/markAsDuplicate`),
  data
});

export const createNewMilestone = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/milestone`),
  data
});

export const checkIssueDeletion = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/milestone/checkIssueBeforeDeletion`
  ),
  data
});

export const checkIssueDisable = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/milestone/checkIssueBeforeDisable`
  ),
  data
});

export const checkIssueDisableBucket = (projectId, bucketId) => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/bucket/getBucketDisableIssueCheck/${projectId}?bucketId=${bucketId}`
  )
});

export const getBuckets = projectId => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/bucket/getBuckets/${projectId}`)
});

export const getTables = (projectId, bucketId) => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/milestoneTableData/getTables/${projectId}/${bucketId}`
  )
});

export const getMilestones = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/milestone/getMilestones`),
  data
});

export const getUploadMeeting = (meetingType, data) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/dashboardMeetings/upload?meetingType=${meetingType}`
  ),
  data: data
});

export const getMeetingTablesData = data => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/dashboardMeetings?march24=${data}`
  )
});

export const getProjectStageWisePendingIssuesService = data => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/chartReport/graph/projectStageWisePendingIssues?march24=${data}`
  )
});

export const getAverageBucketWiseDelayService = data => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/chartReport/barGraph/averageBucketWiseDelay?march24=${data}`
  )
});

export const getProjectStageWisePendingIssuesWithRecipientService = data => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/chartReport/graph/issuesPendingWithRecipientAcrossBucket?march24=${data}`
  )
});

export const downloadUsersListReport = (data = {}) => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/auth/excel/downloadUserDetails"),
  data
});

export const downloadGroupsListReport = (data = {}) => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/auth/excel/downloadGroupDetails"),
  data
});

// PMG Team  Invest India ADD
export const pmgAddMemberForm = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/cms/investindia`),
  data: { ...data }
});

//PMG Invest TEAM GET
export const getPmgInvestApi = activeBoolean => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/cms/investindia?${
      activeBoolean ? "offset=0&limit=50&active=true" : "active=false"
    }`
  )
});

// PMG Invest TEAM EDIT
export const pmgEditMemberFormApi = (data, id) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/cms/investindia/${id}`),
  data: { ...data }
});

// DPIIT ADD

export const dpiitAddMemberForm = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/cms/dpiit`),
  data: { ...data }
});

// DPIIT GET
export const getDpiitInvestApi = activeBoolean => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/cms/dpiit?${
      activeBoolean ? "offset=0&limit=50&active=true" : "active=false"
    }`
  )
});

//DPIIT UPDATE
export const dpiitEditMemberFormApi = (data, id) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/cms/dpiit/${id}`),
  data: { ...data }
});

// SECTION ADD
export const sectionAddMemberForm = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/cms/section`),
  data: { ...data }
});

//SECTION GET
export const sectionPmgInvestApi = activeBoolean => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/cms/section?${
      activeBoolean ? "offset=0&limit=50&active=true" : "active=false"
    }`
  )
});

//SECTION EDIT
export const sectionEditMemberFormApi = (data, id) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/cms/section/${id}`),
  data: { ...data }
});

// HEADING ADD
export const headingAdd = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/cms/heading`),
  data: { ...data }
});

// HEADING GET
export const getHeadingg = (data = {}) => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/project/cms/heading")
});

// HEADING EDIT
export const headingUpdate = (data, id) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/cms/heading/${id}`),
  data: data
});

// http://localhost:8002/project/cms/heading/id

// PMG Updates ADD
export const pmgUpdateAddMemberForm = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/cms/pmgUpdate`),
  data: { ...data }
});

// PMG Updates GET
export const getPmgUpdateApi = activeBoolean => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/cms/pmgUpdate?${
      activeBoolean ? "offset=0&limit=50&active=true" : "active=false"
    }`
  )
});

//PMG Updates EDIT
export const pmgMemberUpdateApi = (data, id) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/cms/pmgUpdate/${id}`),
  data: { ...data }
});

//////////////Landing Page

// CMS GET
export const getDpiitLandingCms = activeBoolean => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/home/dpiit?${
      activeBoolean ? "offset=0&limit=50&active=true" : "active=false"
    }`
  )
});

export const getPmgLandingCms = activeBoolean => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/home/investindia?${
      activeBoolean ? "offset=0&limit=50&active=true" : "active=false"
    }`
  )
});

export const getSectionLandingCms = activeBoolean => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/home/section?${
      activeBoolean ? "offset=0&limit=50&active=true" : "active=false"
    }`
  )
});

export const getPmgUpdateLandingCms = activeBoolean => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/home/pmgUpdate?${
      activeBoolean ? "offset=0&limit=50&active=true" : "active=false"
    }`
  )
});

export const getHeadingLandingCms = activeBoolean => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/home/heading?${
      activeBoolean ? "offset=0&limit=50&active=true" : "active=false"
    }`
  )
});

////////////////// Drag & Drop
export const investIndiaOrder = (data, id) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/cms/investIndiaMember/order/${id}`
  ),
  data: { ...data }
});

export const dpiitOrder = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/cms/dpiitMembers/order`),
  data: { ...data }
});

export const sectionOrder = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/cms/sectionMember/order`),
  data: { ...data }
});

export const getInvestIndiaSortedOrder = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/cms/investIndiaMember/order`),
  data: { ...data }
});

export const getDpiitSortOrder = activeBoolean => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/cms/designation?organizationName=DPIIT Officials` +
      (activeBoolean ? "&active=true" : "&active=false")
  )
});

export const getInvestIndiaSortOrder = activeBoolean => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  // url: GlobalConfig.getApiUrlFromRoot(
  //   `/project/cms/designation?organizationName=INVESTINDIA Officials` +
  //     (activeBoolean ? "offset=0&limit=50&active=true" : "active=false")

  // )
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/cms/designation?organizationName=PMG Invest India Officials` +
      (activeBoolean ? "&active=true" : "&active=false")
  )
});

export const getSectionSortOrder = activeBoolean => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  // url: GlobalConfig.getApiUrlFromRoot(
  //   `/project/cms/designation?organizationName=SECTION Officials?${
  //     activeBoolean ? "offset=0&limit=50&active=true" : "active=false"
  //   }`
  // )
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/cms/designation?organizationName=SECTION Officials` +
      (activeBoolean ? "&active=true" : "&active=false")
  )
});

//ashish sir
export const validatePMGTeamFlds = (data, url) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(url),
  data: { ...data }
});

//jayshri-pragati
export const getUpcommingAgendaFlag = data => {
  return {
    method: "GET",
    headers: GlobalConfig.getHeaders(["JSON"]),
    url: GlobalConfig.getApiUrlFromRoot(`/project/mom/pragati-meetings-alert`)
  };
};

//CR 334 API
export const saveIssueNote = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/issue/editIssueNote`),
  data
});
export const getIssueNote = issueId => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/issue/fetchIssueNote?issueId=${issueId}`
  )
});

//CR-289 API -Yajnadutta
export const getEscalationHistory = issueId => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/issue/escalationHistory?issueId=${issueId}`
  )
});

//Task 350 API - Yajnadutta
export const getDistrictCircle = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/project/getDistrictCircle`),
  data: [...data]
});

export const getSponsoringAgency = (data = {}) => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/project/getSponsoringAgency`),
  data: { ...data }
});

//Task 571 API - Yajnadutta
export const getMinistryForCompliance = (data = {}) => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/user/group/getMinistryForCompliance`)
});

//CR-589 API - Shashank
export const getStateForCompliance = (data = {}) => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/user/group/getStateForCompliance`)
});

export const getStateForComplianceNonPrivate = (data = {}) => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/user/group/getStateForComplianceNonPrivate`
  )
});

export const getStateForCompliancePragati = (data = {}) => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/user/group/getStateForCompliancePragati`
  )
});

//CR-600 API - Yajnadutta
export const downloadMISProjectSummaryAll = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/auth/excel/downloadMISProjectSummaryAll`
  ),
  data: { ...data }
});

//CR-606 API - Yajnadutta
export const downloadMISStateProjectSummaryAll = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/auth/excel/downloadMISStateProjectSummaryAll`
  ),
  data: { ...data }
});

//CR-635 API - Yajnadutta
export const getMinistryForComplianceForNonPrivate = (data = {}) => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/user/group/getMinistryForComplianceForNonPrivate`
  )
});

//CR-913 API- Shashank
export const getMinistryForCompliancePragati = (data = {}) => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/user/group/getMinistryForCompliancePragati`
  )
});

//CR-311 API -Yajnadutta
export const getMigrationLists = taskId => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/task/${taskId}`)
});
//CR-551 API - Yajnadutta
export const dashboardSummaryData = () => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/auth/dashboard-summary/dashboard-summary/grouped-by-month`
  )
});

//CR-551 API - Yajnadutta
export const dashboardSummaryReportDownload = id => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/auth/dashboard-summary/download-dashboard-summary/${id}`
  )
});

//parivesh jayshri
export const getPariveshDetails = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/issue/proposalDetailValidation`
  ),
  data: { ...data }
});

//Parivesh- Shashank
export const proposalDetailValidation = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/issue/proposalDetailValidation`
  ),
  data: { ...data }
});
//CR-672 API - Yajnadutta
export const getAutoCompleteListUsers = id => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/user/user/state-list?tag=${id}`)
});

//CR-768 API - Shashank
export const postCostDistributionData = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/cost-distribution/create`),
  data: data
});

export const getCostDistributionData = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/cost-distribution/getAll`),
  data: data
});

export const updateCostDistributionData = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/cost-distribution/update`),
  data: data
});
//CR-97 API - Jayshri
export const _downloadUploadAgendaTemplate = () => {
  //console.log('calling _downloadUploadAgendaTemplate api');
  return {
    method: "POST",
    responseType: "blob",
    //responseType: 'arraybuffer',
    headers: GlobalConfig.getHeaders(["JSON"]),
    //headers: GlobalConfig.getHeaders([]),
    url: GlobalConfig.getApiUrlFromRoot(
      `/project/mom/downloadProjectIssueExcel`
    )
  };
};

//CR-97 API - Jayshri
export const _uploadProjectIssues = formData => {
  //console.log('In _uploadProjectIssues', formData);
  return {
    method: "POST",
    headers: { "Content-Type": "multipart/form-data" },
    url: GlobalConfig.getApiUrlFromRoot(`/project/mom/upload-excel`),
    data: formData
  };
};

//CR-861 API - Yajnadutta
export const getAIissueSummary = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/ai/summarize`),
  data: data
});

//CR-861 API - Yajnadutta
export const getsimilarIssues = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/ai/similarIssues`),
  data: data
});

//CR-861 API - Yajnadutta
export const gettimelinePrediction = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/ai/timelinePrediction`),
  data: data
});

//CR-861 API - Yajnadutta
export const aiQuestions = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/ai/aiQuestions`),
  data: data
});

//CR-861 API - Yajnadutta
export const getissueUpdates = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/ai/issueUpdates`),
  data: data
});

//CR-861 API - Yajnadutta
export const getactionRecommendation = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/ai/actionRecommendation`),
  data: data
});

//CR-781 - Shashank
export const newsLetters = () => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/auth/fileManger/v2/uploadFile/NEWSLETTER`
  )
});

export const deleteNewsLetter = id => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/auth/fileManger/v2/deleteFile`),
  data: id
});

export const uploadNewsLetter = (data = {}) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["MULTIPART_FORM_DATA"]),
  url: GlobalConfig.getApiUrlFromRoot(`/auth/fileManger/v2/uploadFile`),
  data
});

export const getStatusUpload = id => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/auth/fileManger/v2/fileUploadStatus/${id}`
  )
});
//CR-545 API - Yajnadutta
export const getNotificationsLists = activeBoolean => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/cms/notification?${
      activeBoolean
        ? "offset=0&limit=50&active=true"
        : "offset=0&limit=50&active=false"
    }`
  )
});

//CR-545 API - Yajnadutta
export const addNotifications = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/cms/notification`),
  data: data
});

//CR-545 API - Yajnadutta
export const notificationsOrder = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/cms/notification/order`),
  data: { ...data }
});

//CR-545 API - Yajnadutta
export const deleteNotificationAPI = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/cms/notification/delete`),
  data: { ...data }
});

//CR-545 API - Yajnadutta
export const updateNotifications = (data, id) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/cms/notification/${id}`),
  data: { ...data }
});

//CR-545 API - Yajnadutta
export const getLandingPageNotifications = () => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    "/project/home/notification?offset=0&limit=100"
  )
});

//CR-837 API - Yajnadutta
export const getGroupHierarchy = id => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/user/group/hierarchy-view/${id}`)
});

//CR-922 API - Yajnadutta
export const getAIprojectSummary = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/ai/projectSummary`),
  data: data
});

//CR-922 API - Yajnadutta
export const getAIsimilarProjects = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/ai/similarProjects`),
  data: data
});

//CR-929 AI chatbot - Shashank

export const chatBotQuery = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/ai/chatbot/query`),
  data: data
});

export const chatBotfeedback = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/ai/feedback`),
  data: data
});

//CR-810 API - Yajnadutta
export const approveComment = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/project/issue/comment/approve"),
  data: data
});
//CR-1037 API - Shashank
export const getProjectActionItem = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/ai/projectActionItem`),
  data: data
});

//CR-1031 AI - Shashank
export const getProjectRecommendation = id => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/ai/project-recommendation?projectId=${id}`
  )
});
export const getProjectRecommendationQuestions = id => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/ai/project-recommendation-questions?projectId=${id}`
  )
});

//CR-779-Frontend
export const addArticle = data => ({
  method: "POST", // Assuming POST for submission; adjust if needed (e.g., PUT for update)
  headers: GlobalConfig.getHeaders(["JSON"]), // Uses your app's global headers
  url: GlobalConfig.getApiUrlFromRoot("/project/api/articles"), // Your provided endpoint
  data: { ...data } // Pass the article data here
});
export const updateArticle = (data, id) => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/api/articles/update/${id}`),
  data: { ...data }
});
export const getArticlesApi = ({
  offset = 0,
  limit = 10,
  active = true
} = {}) => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/api/articles?${serialize({ offset, limit, active })}`
  )
});
export const articlesTags = data => ({
  method: "POST", // Assuming POST for submission; adjust if needed (e.g., PUT for update)
  headers: GlobalConfig.getHeaders(["JSON"]), // Uses your app's global headers
  url: GlobalConfig.getApiUrlFromRoot("/project/api/tags/all"), // Your provided endpoint
  data: { ...data } // Pass the article data here
});
export const addTags = data => ({
  method: "POST",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot("/project/api/tags"),
  data: data // Pass the tag payload exactly as provided
});
export const getArticleDetailsById = id => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(`/project/home/articles/${id}`)
});

export const getOtherArticles = id => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/home/articles?offset=0&limit=50&active=true`
  )
});
export const getLatestArticlesApi = ({
  offset = 0,
  limit = 4,
  active = true
} = {}) => ({
  method: "GET",
  headers: GlobalConfig.getHeaders(["JSON"]),
  url: GlobalConfig.getApiUrlFromRoot(
    `/project/home/articles?${serialize({ offset, limit, active })}`
  )
});

export const latestArticles = getLatestArticlesApi;

//CR-1036 API - Jayshri
export const verifyUser = (accessToken_t, data) => ({
  method: "POST",
  headers: {
    ...GlobalConfig.getHeaders(["JSON"]),
    Authorization: `Bearer ${accessToken_t}`
  },
  url: GlobalConfig.getApiUrlFromRoot("/auth/getUserDetails"),
  data: data
});
